import * as React from 'react'

function SvgIconBrightnessMax(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
      <g
        id="brightness-max"
        aria-labelledby="t-brightness-max d-brightness-max"
      >
        <title id="t-brightness-max">{'Brightness max'}</title>
        <desc id="d-brightness-max">{'A circle radiating 8 long lines'}</desc>
        <path d="M16 12c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4zm0 10c-3.3 0-6-2.7-6-6s2.7-6 6-6 6 2.7 6 6-2.7 6-6 6zM9.6 10.6c-.3 0-.5-.1-.7-.3L4.7 6.1c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0l4.2 4.2c.4.4.4 1 0 1.4-.2.2-.4.3-.7.3zM7 17H1c-.6 0-1-.4-1-1s.4-1 1-1h6c.6 0 1 .4 1 1s-.4 1-1 1zM5.4 27.6c-.3 0-.5-.1-.7-.3-.4-.399-.4-1 0-1.399l4.2-4.188c.4-.396 1-.396 1.4 0 .4.396.4 1 0 1.396l-4.2 4.197c-.2.194-.5.294-.7.294zM16 32c-.6 0-1-.4-1-1v-6c0-.6.4-1 1-1s1 .4 1 1v6c0 .6-.4 1-1 1zm10.6-4.4c-.3 0-.5-.1-.699-.3l-4.188-4.2a.969.969 0 010-1.396.964.964 0 011.396 0l4.197 4.196c.396.396.396 1 0 1.396-.206.204-.406.304-.706.304zM31 17h-6c-.6 0-1-.4-1-1s.4-1 1-1h6c.6 0 1 .4 1 1s-.4 1-1 1zm-8.6-6.4c-.301 0-.5-.1-.7-.3-.4-.4-.4-1 0-1.4l4.2-4.2c.396-.4 1-.4 1.396 0 .399.4.399 1 0 1.4L23.1 10.3c-.2.2-.5.3-.7.3zM16 8c-.6 0-1-.4-1-1V1c0-.6.4-1 1-1s1 .4 1 1v6c0 .6-.4 1-1 1z" />
      </g>
    </svg>
  )
}

export default SvgIconBrightnessMax
